import moment from 'moment';
import {isObject} from "lodash";

export const dateMethods = {
  methods: {
    formatDate(date, format='L', show_safe_string) {
      if (!date) {
        return show_safe_string ? 'No data available' : null
      } else {
        return moment(date).format(format)
      }
    },
    getCurrentDate () {
      return new moment().format('L')
    },
    getThisMonth () {
      return new moment().format('MMM')
    },
    getLastMonth () {
      return new moment().subtract(1, 'month').format('MMM');
    }
  }
};

export const datePickerMethods = {
  methods: {
    datePickerInputFormalize(value, dateFormat = 'MM/DD/YYYY') {
      if(value && value.start && value.end) {
        return `${this.formatDate(value.start, dateFormat)} - ${this.formatDate(value.end, dateFormat)}`
      }
      return this.formatDate(value, dateFormat);
    }
  }
}
